import type { ComponentChildren } from 'preact';

interface ButtonSecondaryProps {
  onClick: () => void;
  children: ComponentChildren;
  disabled?: boolean;
  'aria-label'?: string;
}

export function ButtonSecondary({
  onClick,
  children,
  disabled = false,
  'aria-label': ariaLabel,
}: ButtonSecondaryProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={ariaLabel}
      class="w-full py-2.5 px-6 rounded-lg font-medium text-hudson-navy text-base border border-hudson-navy hover:bg-hudson-navy/5 active:bg-hudson-navy/10 focus:outline-none focus:ring-2 focus:ring-hudson-navy focus:ring-offset-2 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
    >
      {children}
    </button>
  );
}
